import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import classes from "./ProductSection.module.css";

// Shared outer shell for the three "main product" homepage sections (Atpūtas ceļojumi, Avio
// ceļojumi, Autobusu ceļojumi) — same container width, header layout, view-all button, arrow
// controls and dot pagination for all three, so they read as one design system. Only the accent
// color, icon and inner content (passed as children) differ per section. Cheap-hotels keeps its
// own pre-existing layout — it isn't one of the three unified sections.
export function ProductSection({
  accentColor,
  sectionStyle,
  sectionClassName,
  decor,
  icon,
  title,
  subtitle,
  viewAllLabel,
  onViewAll,
  canPrev,
  canNext,
  onPrev,
  onNext,
  dotCount = 0,
  activeDot = 0,
  onDotClick,
  children,
}) {
  const showArrows = !!onPrev && !!onNext;

  return (
    <section
      className={`${classes.section} ${sectionClassName || ""}`}
      style={{ "--section-color": accentColor, ...sectionStyle }}>
      {decor}
      <div className={classes.container}>
        <div className={classes.header}>
          <div className={classes.headerLeft}>
            <span className={classes.iconCircle}>{icon}</span>
            <div className={classes.titleBlock}>
              <h2 className={classes.title}>{title}</h2>
              <p className={classes.subtitle}>{subtitle}</p>
            </div>
          </div>

          <div className={classes.headerRight}>
            {onViewAll && (
              <button type="button" className={classes.viewAllButton} onClick={onViewAll}>
                {viewAllLabel}
                <IconChevronRight size={16} stroke={2} />
              </button>
            )}
            {showArrows && (
              <div className={classes.arrows}>
                <button
                  type="button"
                  aria-label="previous"
                  className={classes.arrowButton}
                  disabled={!canPrev}
                  onClick={onPrev}>
                  <IconChevronLeft size={20} stroke={1.75} />
                </button>
                <button
                  type="button"
                  aria-label="next"
                  className={`${classes.arrowButton} ${classes.arrowButtonNext}`}
                  disabled={!canNext}
                  onClick={onNext}>
                  <IconChevronRight size={20} stroke={1.75} />
                </button>
              </div>
            )}
          </div>
        </div>

        {children}

        {dotCount > 1 && (
          <div className={classes.dots}>
            {Array.from({ length: dotCount }, (_, i) => (
              <button
                key={i}
                type="button"
                aria-label={`slide ${i + 1}`}
                className={`${classes.dot} ${i === activeDot ? classes.dotActive : ""}`}
                onClick={() => onDotClick?.(i)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
